import { createHttpLink } from '@apollo/client'
import { createUploadLink } from 'apollo-upload-client'

const { REACT_APP_API_URL, REACT_APP_SIMULADO_API_URL } = process.env

const httpLink = createUploadLink({
  uri: REACT_APP_API_URL,
})

const mockExamsPlatformLink = createHttpLink({
  uri: `${REACT_APP_SIMULADO_API_URL}/graphql`,
})

export { httpLink, mockExamsPlatformLink }
